// SignalR constants - kept separate to avoid circular dependencies with store modules

export const SIGNALR_CONNECTION_STATE = {
    Connected: 'Connected'
};

export const SIGNALR_TIMEOUTS = {
    serverTimeoutInMilliseconds: 60000,
    keepAliveIntervalInMilliseconds: 15000
};
